import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Input, Label, Button } from "../../shared/components";

const CustomerForm = ({ 
  customerInfo, 
  updateCustomerInfo, 
  isFormValid, 
  onCompleteReservation,
  isCreatingReservation = false,
  isModifyingReservations = false,
  submitLabel,
}) => {
  const buttonText = isCreatingReservation 
    ? (isModifyingReservations ? 'Actualizando Reserva...' : 'Creando Reserva...') 
    : (submitLabel || (isModifyingReservations ? 'Actualizar Reserva' : 'Completar Reserva'));

  return (
    <Card>
      <CardHeader className="pb-3 sm:pb-4">
        <CardTitle className="text-base sm:text-lg">Información</CardTitle>
        <CardDescription className="text-xs sm:text-sm">
          {isModifyingReservations 
            ? 'Verifica tus datos para actualizar la reserva' 
            : 'Proporciona tus datos para completar la reserva'
          }
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 sm:space-y-4">
        <div>
          <Label htmlFor="name" className="text-xs sm:text-sm font-medium text-gray-700">
            Nombre
          </Label>
          <Input
            id="name"
            value={customerInfo.name}
            onChange={(e) => updateCustomerInfo('name', e.target.value)}
            placeholder="Ingresa tu nombre completo"
            className="mt-1 h-9 sm:h-10 text-sm sm:text-base"
          />
        </div>
        <div>
          <Label htmlFor="telefono" className="text-xs sm:text-sm font-medium text-gray-700">
            Teléfono Celular
          </Label>
          <Input
            id="telefono"
            type="telefono"
            value={customerInfo.phone}
            onChange={(e) => updateCustomerInfo('phone', e.target.value)}
            placeholder="Ingresa tu teléfono celular"
            className="mt-1 h-9 sm:h-10 text-sm sm:text-base"
          />
        </div>
        <Button
          onClick={onCompleteReservation}
          className="w-full h-10 sm:h-12 text-sm sm:text-base font-semibold bg-blue-600 hover:bg-blue-700 mt-4 sm:mt-6"
          size="lg"
          disabled={!isFormValid() || isCreatingReservation}
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
};

export default CustomerForm; 